var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0671 47.3661H35.9338M24.5005 47.3661V31.0328M24.5005 31.0328C31.717 31.0328 37.5671 25.1827 37.5671 17.9661V4.89948C37.5671 3.09535 36.1046 1.63281 34.3005 1.63281H14.7005C12.8963 1.63281 11.4338 3.09535 11.4338 4.89948V17.9661C11.4338 25.1827 17.2839 31.0328 24.5005 31.0328ZM11.4338 8.16615H8.16712C4.55886 8.16615 1.63379 11.0912 1.63379 14.6995C1.63379 18.3077 4.55886 21.2328 8.16712 21.2328H11.4338M37.5671 8.16615H40.8338C44.442 8.16615 47.3671 11.0912 47.3671 14.6995C47.3671 18.3077 44.442 21.2328 40.8338 21.2328H37.5671",
    stroke: "#13100D",
    strokeWidth: 2.72222
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.07aebbf82290fabb1c9412003cd6e99b.svg";
export { ForwardRef as ReactComponent };